import { call, put } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

// eslint-disable-next-line import/prefer-default-export
export function* markDocumentReadCPI({ payload }) {
  yield put(actions.setCPIReadingLoading(true));
  try {
    yield call(Api.markDocumentRead, {
      document_read: payload,
      cpi: true,
    });
    yield put(actions.setCPIReadingLoading(false));
  } catch (error) {
    yield put(actions.addError("Reading List CPI", error));
    yield put(actions.setCPIReadingLoading(false));
  }
}
